<template>
    <span v-if="notificationsCount > 0" :class="animateClass" class="notification-badge position-absolute top-0 start-100 translate-middle badge rounded-pill">
        {{ notificationsCount }}
        <span class="visually-hidden">{{ unreadmessageslabel }}</span>
    </span>
</template>

<script>
    export default {
        props: [
            'startingconversationscount',
            'unreadmessageslabel',
            'currentuserid',
            'listentobroadcast'
        ],

        data() {
            return {
                notificationsCount: this.startingconversationscount ?? 0,
                animateClass: ''
            }
        },

        mounted() {
            this.echoChannelListening();
            this.eventsListening();
        },

        methods: {
            echoChannelListening() {
                var _this = this;
                var listenToBroadcast = JSON.parse(this.listentobroadcast);
                _.forEach(listenToBroadcast, function(broadcastChannel) {
                    Echo.private(broadcastChannel)
                        .listen('ChatMessageCreated', (e) => {
                            _this.getUnreadNotificationsCount();
                        });
                });

            },

            eventsListening() {
                var _this = this;
                jQuery(document).ready(function() {
                    Livewire.on('conversationRead', (selectedConversationId) => {
                        _this.getUnreadNotificationsCount();
                    });
                })
            },

            getUnreadNotificationsCount() {
                var _this = this;
                axios.get('/messages/count').then((response) => {
                    var data = response.data;
                    if (data.success) {
                        _this.notificationsCount = data.count;
                        _this.animateBadge();
                    }
                })
            },

            animateBadge() {
                var _this = this;
                _this.animateClass = 'animate';
                setTimeout(function() {
                    _this.animateClass = '';
                }, 6000)
            }
        }
    }
</script>